import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ISearchDropdownItem } from '../SearchDropdown';
import {
  ArrowCont,
  DropContentCont,
  DropDownStaticHead,
  DropDownStaticPlaceholder,
  ErrorMessage,
  ErrorStaticIconCont,
  InfoStaticIconCont,
  InfoStaticMessage,
  SearchDropInputCont,
  SortArrowCont,
  SortArrowsCont,
  SortUpArrowCont,
  StaticErrorMsgCont,
  StaticIconImg,
  Label,
  ClearAction,
} from './SearchStaticHeader.styles';
import ArrowFilledIcon from '@/assets/icons/arrow_filled_black.svg?react';
import ArrowIcon from '@/assets/icons/arrowRightIcon.svg?react';
import ErrorInputIcon from '@/assets/icons/errorInputIcon.svg?react';
import ErrorMsgIcon from '@/assets/icons/errorMsgIcon.svg?react';
import InfoIcon from '@/assets/icons/infogrey.svg?react';

interface ISearchStaticHeader {
  active: boolean;
  activeEl?: ISearchDropdownItem | string;
  error?: string;
  infoMessage?: string;
  placeholder?: string;
  setActive: (value: boolean) => void;
  width?: string;
  shortFlags?: boolean;
  sortMethod?: (value: string) => void;
  label?: string;
  clearAction?: () => void;
  highlighted?: boolean;
  sortingState?: string | null;
  isDisabled?: boolean;
}

const SearchStaticHeader: FC<ISearchStaticHeader> = ({
  active,
  activeEl,
  error,
  infoMessage,
  placeholder,
  setActive,
  width,
  shortFlags,
  sortMethod,
  label,
  clearAction,
  highlighted,
  sortingState,
  isDisabled,
}) => {
  const isActiveElObject = typeof activeEl === 'object' && activeEl !== null;
  const activeElObject = isActiveElObject ? activeEl : undefined;
  const nameToDisplay = shortFlags ? activeElObject?.shortDisplayName : activeElObject?.name;
  const activeElName = isActiveElObject ? nameToDisplay || '' : activeEl;
  const { t } = useTranslation();
  return (
    <DropContentCont>
      {clearAction && (
        <ClearAction data-testid="staticClear" onClick={clearAction}>
          {t('report.groupComparison.clear')}
        </ClearAction>
      )}
      <Label data-testid="input-label">{label}</Label>
      <SearchDropInputCont
        highLighted={highlighted}
        onClick={() => setActive(!active)}
        error={!!error}
        width={width}
        isDisabled={isDisabled}
      >
        {!!infoMessage && !error && (
          <InfoStaticIconCont data-testid="infoBelowInputStatic">
            <InfoIcon /> <InfoStaticMessage>{infoMessage}</InfoStaticMessage>
          </InfoStaticIconCont>
        )}
        {!!error && (
          <ErrorStaticIconCont>
            <ErrorInputIcon />
          </ErrorStaticIconCont>
        )}
        {activeEl ? (
          <DropDownStaticHead isDisabled={isDisabled}>
            {activeElObject?.icon && <StaticIconImg src={activeElObject.icon} />}
            {activeElName}
          </DropDownStaticHead>
        ) : (
          <DropDownStaticPlaceholder>{placeholder}</DropDownStaticPlaceholder>
        )}
        {!isDisabled && (
          <ArrowCont
            sortFeature={!!sortMethod}
            data-testid="dropArrowInSearchHeader"
            active={active}
            onClick={() => setActive(!active)}
          >
            <ArrowIcon />
          </ArrowCont>
        )}
      </SearchDropInputCont>
      {!!error && (
        <StaticErrorMsgCont data-testid="errorBelowStatic">
          <ErrorMsgIcon /> <ErrorMessage>{error}</ErrorMessage>
        </StaticErrorMsgCont>
      )}
      {!!sortMethod && (
        <SortArrowsCont highlighted={highlighted}>
          <SortArrowCont
            active={sortingState === 'desc'}
            data-testid="DescSortArrow"
            onClick={() => sortMethod('desc')}
          >
            <ArrowFilledIcon />
          </SortArrowCont>
          <SortUpArrowCont
            active={sortingState === 'asc'}
            data-testid="AscSortArrow"
            onClick={() => sortingState !== 'asc' && sortMethod('asc')}
          >
            <ArrowFilledIcon />
          </SortUpArrowCont>
        </SortArrowsCont>
      )}
    </DropContentCont>
  );
};

export default SearchStaticHeader;
